export const initialState = {
  loading: false,
  customer: null,
  customers: [],
  response: { message: null, error: null },
};
